// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5714 ? "11a89e4f" : chunkId) + "." + {"1876":"2daf26493e99eb6e","2004":"3182ae1a4be1a71e","3829":"370d619b512d055d","5714":"9f828ea6a193df23"}[chunkId] + ".js";
};